import LabelValueText from "@/src-refactor/modules/shared/components/typography/label-value-text/LabelValueText";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import { useEffect } from "react";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import { Chip, styled } from "@mui/material";
import dayjs from "dayjs";
import { A_PROPERTY_INFORMATION_VISITS } from "@/src-refactor/modules/shared/model/const/property/ information-visits.const";
import MoneyFormat from "@/src-refactor/modules/shared/helpers/moneyFormat.helper";

const GeneralInformation = () => {
  const {
    PROPERTY_DETAIL: { principalData, project }
  } = useRealEstateDetailContext();

  useEffect(() => {}, []);

  const getVisitName = (visitId: any) => {
    const visitInfo = A_PROPERTY_INFORMATION_VISITS.find(
      item => item.id === visitId
    );
    return visitInfo ? visitInfo.name : "Desconocido";
  };

  const notVisibleIf = (data: string | number) => {
    return data !== undefined && data !== null && data !== 0;
  };

  return (
    <Container>
      <TextSimple color="blue" size="title" font="gotham" weight="bold">
        Información general
      </TextSimple>

      <ContainerInfo>
        {principalData.general_information.property_status && (
          <LabelValueText
            label="Estado del inmueble"
            value={principalData.general_information.property_status}
          />
        )}

        <LabelValueText
          label="Uso del inmueble"
          value={principalData.general_information.property_use}
        />

        {principalData.general_information.ref_point && (
          <LabelValueText
            label="Punto de ref."
            value={principalData.general_information.ref_point}
          />
        )}
        {principalData.general_information.position && (
          <LabelValueText
            label="Posición"
            value={principalData.general_information.position}
          />
        )}
        <LabelValueText
          label="Tipo de arreglo"
          value={principalData.general_information.type_of_arrangement}
        />
        <LabelValueText
          label="Detalles del negocio"
          value={principalData.general_information.business_details}
        />

        {notVisibleIf(principalData.floors_total) && (
          <LabelValueText
            label="Total de pisos"
            value={principalData.floors_total.toString()}
          />
        )}

        {notVisibleIf(principalData.half_bathrooms) && (
          <LabelValueText
            label="Medios baños"
            value={principalData.half_bathrooms.toString()}
          />
        )}

        {principalData.maintenance_fee && (
          <LabelValueText
            label="Mantenimiento"
            value={MoneyFormat(principalData.maintenance_fee)}
          />
        )}

        {getVisitName(principalData.visit) !== "Desconocido" && (
          <LabelValueText
            label="Información de visitas"
            value={getVisitName(principalData.visit)}
          />
        )}
        {!project && (
          <LabelValueText
            label="¿Está habitado?"
            value={principalData.is_inhabited}
          />
        )}
        {principalData.general_information.escrow_name && (
          <LabelValueText
            label="Fideicomiso"
            value={principalData.general_information.escrow_name}
          />
        )}
        {principalData.general_information.delivers && (
          <LabelValueText
            label="Fecha de entrega"
            value={dayjs(principalData.general_information.delivers).format(
              "DD/MM/YYYY"
            )}
          />
        )}
      </ContainerInfo>

      {principalData.property_characteristics.length > 0 && (
        <>
          <TextSimple color="blue" size="title" font="gotham">
            Características de la propiedad
          </TextSimple>
          <CharacteristicsContainer>
            {principalData.property_characteristics.map(item => (
              <LabelValueText
                label={item.label}
                value={item.value}
                key={item.label}
                position="col"
              />
            ))}
          </CharacteristicsContainer>
        </>
      )}

      {principalData.improvements.length > 0 && (
        <>
          <TextSimple color="blue" size="title" font="gotham" weight="700">
            Mejoras y Amenidades
          </TextSimple>

          <ImprovementsContainer>
            {principalData.improvements.map(item => (
              <CustomChip key={item} label={item} />
            ))}
          </ImprovementsContainer>
        </>
      )}
    </Container>
  );
};

export default GeneralInformation;

const Container = styled("div")(({ theme }) => ({
  marginTop: "20px"
}));

const ContainerInfo = styled("div")(({ theme }) => ({
  marginTop: "10px",
  width: "100%",
  display: "grid",
  gridTemplateColumns: "repeat(2, 40%)",
  columnGap: "10%",
  rowGap: "5px",
  marginBottom: "20px"
}));

const CharacteristicsContainer = styled("div")(({ theme }) => ({
  marginTop: "10px",
  marginBottom: "20px",
  flexWrap: "wrap",
  display: "flex",
  gap: "20px"
}));

const ImprovementsContainer = styled("div")(({ theme }) => ({
  width: "100%",
  marginTop: "10px",
  marginBottom: "10px",
  display: "flex",
  gap: "12px",
  flexWrap: "wrap"
}));

const CustomChip = styled(Chip)(({ theme }) => ({
  background: "#d9d9d9",
  color: "var(--color-blue-main)",
  fontSize: "13px",
  fontWeight: 500,
  fontFamily: "var(--ff-gotham) !important",
  height: "26px",
  padding: "0 10px"
}));
